import axios from "axios";

let lastErrorFingerprint = null;

export function logErrorOnce(errorObj) {
  const fingerprint = JSON.stringify({
    message: errorObj.message,
    stack: errorObj.stack,
  });

  if (lastErrorFingerprint === fingerprint) {
    return; // Skip duplicate error
  }

  lastErrorFingerprint = fingerprint;

  axios.post(`${process.env.REACT_APP_API_URL}/log/react-error`, errorObj)
    .catch(() => {});
}
